import { jsx } from "react/jsx-runtime";
import DocumentCard from "./DocumentCard.js";
import DocCards from "./DocumentCards.js";
const RichTextEditor = (props) => {
  if (props.multiple) {
    const { multiple: multiple2, ...documentCardsProps } = props;
    return /* @__PURE__ */ jsx(DocCards, { ...documentCardsProps });
  }
  const { multiple, docs, onSave, ...documentCardProps } = props;
  return /* @__PURE__ */ jsx(DocumentCard, { doc: docs, onSaveDocument: onSave, ...documentCardProps });
};
export {
  RichTextEditor as default
};
